import React from 'react';
import { Query, QueryResult, useQuery } from 'react-apollo';
import gql from 'graphql-tag';
import get from 'lodash.get';

import { utils, PatientToDo } from 'kb-shared';
import { Appointment } from 'kb-shared';

import ToDoIngestor from './components/ToDoIngestor';

type IntakeTodoResult = QueryResult<{
  formCompletion: {
    id: string;
    percentageComplete: number;
  };
  patientTodos: PatientToDo[];
}>;

export const INTAKE_AND_TODO = gql`
  query formAndTodo($formId: Int!) {
    formCompletion(formId: $formId) {
      id
      percentageComplete
    }
    patientTodos {
      id
      todoId
      title: name
      linkUrl
      buttonText
      description
      completed
      order
      headingText
      category
    }
  }
`;
interface PatientResponse {
  patient: {
    id: string;
    createdAt: string;
  };
}

const patientQuery = gql`
  query patient {
    patient {
      id
      createdAt
    }
  }
`;

type Props = {
  appointments: Appointment[];
  gender: 'male' | 'female' | undefined;
};

function ToDoItems(props: Props) {
  const { data } = useQuery(patientQuery);
  const patientSinceDate = new Date(data?.patient?.createdAt);
  // this is the date since the new ToDo item to upload ID was implemented, after which we show the item
  const dateToShowUploadID = new Date('2021-12-16');
  const showUploadID = dateToShowUploadID <= patientSinceDate;
  return (
    <Query
      query={INTAKE_AND_TODO}
      variables={{ formId: utils.intakeFormId(process.env.REACT_APP_ENV, props.gender) }}
    >
      {({ data, error, loading }: IntakeTodoResult) => {
        if (loading || error || !data || !data.patientTodos) {
          return null;
        }
        const intakeFormCompletionPercent = get(data, 'formCompletion.percentageComplete', null);
        const patientTodos = get(data, 'patientTodos', []);
        return (
          <ToDoIngestor
            intakeFormCompletionPercent={intakeFormCompletionPercent}
            appointments={props.appointments}
            apiTodos={patientTodos}
            showUploadID={showUploadID}
          />
        );
      }}
    </Query>
  );
}

export default ToDoItems;
